import{useRef as s,useEffect as e}from"../external/preact/hooks/dist/hooks.js";const o=()=>{const o=s(null);return e((()=>{var s;null===(s=o.current)||void 0===s||s.focus()}),[]),o};export{o as default};
//# sourceMappingURL=useAutoFocus.js.map
